import { FC } from "react";
import { useRecoilValue } from "recoil";

import { RASTER_LANDINGS } from "@ryde/assets-landings";
import {
  landingActiveStepAtom,
  LandingStepEnum,
  useLandingActions,
  useLandingLangSwitch,
} from "@ryde/utils-landings";

import {
  StepErrorTnufa,
  StepFinishedTnufa,
  StepLoginTnufa,
  StepVerifyCodeTnufa,
} from "../../steps-tnufa";

export const TnufaLandingStepsContainer: FC = () => {
  const step = useRecoilValue(landingActiveStepAtom);
  const { goToStep } = useLandingActions();
  useLandingLangSwitch();

  return (
    <main className="landing-outside-container">
      <div className="landing-container">
        <button
          type="button"
          className="landing-logo"
          onClick={() => goToStep(LandingStepEnum.LoginStep)}
          aria-label="Go to homepage"
        >
          <img
            className="landing-logo__img"
            src={RASTER_LANDINGS.TnufaLogoJPG}
            alt="Tnufa logo"
            width="370"
            height="114"
          />
        </button>
        {(!step || step === LandingStepEnum.LoginStep) && <StepLoginTnufa />}
        {step === LandingStepEnum.VerificationStep && <StepVerifyCodeTnufa />}
        {step === LandingStepEnum.FinishedStep && <StepFinishedTnufa />}
        {step === LandingStepEnum.ErrorStep && <StepErrorTnufa />}
      </div>
    </main>
  );
};
